import $ from 'jquery';

import * as success from '../actions/FirmaActions';

import endpoint from '../environments/endpoints';
import { showAlert } from '../utils/ErrorHandler';

export function getFirma(onSuccess, onError) {
    return function(dispatch) {
        $.ajax({
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + sessionStorage.token
            },
            url: endpoint.apiEndpoint + 'firma'
        })
            .done(data => {
                dispatch(success.getFirma(data));
            })
            .fail(error => {
                showAlert(error);
            });
    };
}

export function createOrUpdateFirma(firma, onSuccess, onError) {
    return function(dispatch) {
        $.ajax({
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + sessionStorage.token
            },
            url: endpoint.apiEndpoint + 'firma',
            data: JSON.stringify(firma)
        })
            .done(data => {
                dispatch(success.getFirma(data));
            })
            .fail(error => {
                showAlert(error);
            });
    };
}
